// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__MUz6q","itemTitle":"ClientEmergencyInfo_itemTitle__3Pa56","itemText":"ClientEmergencyInfo_itemText__-o9j9"};